import { RootState, TypedDispatch } from "../../../../redux/store";
import { connect } from "react-redux";
import {
  AddEnquiryDataFromContact,
  DeleteContactData,
  DeleteInboundEmailData,
  EmailConfigDTO,
  EmailConfigData,
  ImapSyncData,
  ImportCSVData,
  InboundInitialStateDTO,
} from "../service/types";
import {
  configEmail,
  deleteInboundEmail,
  getCsvTemplate,
  getContactList,
  getMailConfigsList,
  getMailEntriesByInstitute,
  imapSyncEmail,
  importCsvFile,
  saveEmailConfigDetails,
  deleteContactList,
  addEnquiryForContact,
} from "../service/inboundSlice";
import { NurtureLead } from "../../Nurture/service/types";
import {
  getNurtureLeadBoard,
  nurtureLead,
} from "../../Nurture/service/nurtureSlice";
import {
  getAllCourseByInstituteRequest,
  getCourseByIdRequest,
} from "../../Manage/ManageCourse/service/courseSlice";
import { getBranchList } from "../../Manage/ManageBranch/service/Branchslice";
import {
  getBatchById,
  getBatchList,
} from "../../Manage/ManageBatch/service/Batchslice";
import { getInstituteById } from "../../Manage/InstituteProfile/service/instituteSlice";
import EmailData from "../components/SyncedDataTab/EmailData";

interface StateProps extends InboundInitialStateDTO {}

interface DispatchProps {
  CongigEmail(data: EmailConfigDTO): void;
  CreateEnquiry(data: NurtureLead): void;
  GetMailConfigList(id: string): void;
  GetMailsEntriesByInstitute(
    id: string,
    lastEvaluatedKey: string,
    limit: number,
    lastEvaluatedSortKey: string
  ): void;
  SaveEmailConfigurationDetails(data: EmailConfigData): void;
  GetNurtureLeadBoard(id: string): void;
  DeleteEmails(data: DeleteInboundEmailData): void;
  ImapEmailSync(data: ImapSyncData): void;
  DownloadCSVTemplate(data: any): void;
  ImportCSVFile(body: ImportCSVData): void;
  GetCourseList(id: string): void;
  GetContactLists(
    id: string,
    lastEvaluatedKey: string,
    limit: number,
    lastEvaluatedSortKey: string,
    branchId: string
  ): void;
  DeleteContactList(data: DeleteContactData): void;
  GetBranchList(id: string): void;
  GetCourseList(id: string): void;
  GetBatchList(data: any): void;
  GetNurtureLeadBoard(id: string): void;
  AddEnquiryForContact(data: AddEnquiryDataFromContact): void;
  GetInstituteById(id: string): void;
  GetCourseById(id: string): void;
  GetBatchById(id: string): void;
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    success: state.inbound.success,
    error: state.inbound.error,
    loading: state.inbound.loading,
    mailList: state.inbound.mailList,
    mailById: state.inbound.mailById,
    mailConfigsList: state.inbound.mailConfigsList,
    importCsvData: state.inbound.importCsvData,
    templateData: state.inbound.templateData,
    importHistoryData: state.inbound.importHistoryData,
    contactList: state.inbound.contactList,
    downloadHistoryData: state.inbound.downloadHistoryData,

    emailConfigSuccess: state.inbound.emailConfigSuccess,
    emailConfigError: state.inbound.emailConfigError,
    emailConfigLoading: state.inbound.emailConfigLoading,
    deleteEmailSuccess: state.inbound.deleteEmailSuccess,
    deleteEmailError: state.inbound.deleteEmailError,
    deleteEmailLoading: state.inbound.deleteEmailLoading,
    imapSyncLoading: state.inbound.imapSyncLoading,
    imapSyncSuccess: state.inbound.imapSyncSuccess,
    imapSyncError: state.inbound.imapSyncError,
    emailDetailsLoading: state.inbound.emailDetailsLoading,
    emailDetailsSuccess: state.inbound.emailDetailsSuccess,
    emailDetailsError: state.inbound.emailDetailsError,
    templateDownloadError: state.inbound.templateDownloadError,
    templateDownloadLoading: state.inbound.templateDownloadLoading,
    templateDownloadSuccess: state.inbound.templateDownloadSuccess,
    importCsvLoading: state.inbound.importCsvLoading,
    importCsvSuccess: state.inbound.importCsvSuccess,
    importCsvError: state.inbound.importCsvError,
    contactListLoading: state.inbound.contactListLoading,
    contactListSuccess: state.inbound.contactListSuccess,
    contactListError: state.inbound.contactListError,
    deleteContactLoading: state.inbound.deleteContactLoading,
    deleteContactSuccess: state.inbound.deleteContactSuccess,
    deleteContactError: state.inbound.deleteContactError,
    addedEnquiryContactLoading: state.inbound.addedEnquiryContactLoading,
    addedEnquiryContactSuccess: state.inbound.addedEnquiryContactSuccess,
    addedEnquiryContactError: state.inbound.addedEnquiryContactError,
    otherEmailConfigLoading: state.inbound.otherEmailConfigLoading,
    otherEmailConfigSuccess: state.inbound.otherEmailConfigSuccess,
    otherEmailConfigError: state.inbound.otherEmailConfigError,
    importHistoryLoading: state.inbound.importHistoryLoading,
    downloadHistoryDataSuccess: state.inbound.downloadHistoryDataSuccess,
    downloadHistoryDataError: state.inbound.downloadHistoryDataError,
    downloadHistoryDataLoading: state.inbound.downloadHistoryDataLoading,
    inboundDeactivateError: state.inbound.inboundDeactivateError,
    inboundDeactivateSuccess: state.inbound.inboundDeactivateSuccess,
    inboundDeactivateLoading: state.inbound.inboundDeactivateLoading,
  };
};

const mapDispatchToProps = (dispatch: TypedDispatch): DispatchProps => {
  return {
    CongigEmail: (data: EmailConfigDTO) => {
      dispatch(configEmail(data));
    },
    CreateEnquiry: (data: NurtureLead) => {
      dispatch(nurtureLead(data));
    },
    GetMailConfigList: (id: string) => {
      dispatch(getMailConfigsList(id));
    },
    GetMailsEntriesByInstitute: (
      id: string,
      lastEvaluatedKey: string,
      limit: number,
      lastEvaluatedSortKey: string
    ) => {
      dispatch(
        getMailEntriesByInstitute({
          id,
          lastEvaluatedKey,
          limit,
          lastEvaluatedSortKey,
        })
      );
    },
    SaveEmailConfigurationDetails: (data: any) => {
      dispatch(saveEmailConfigDetails(data));
    },
    GetNurtureLeadBoard: (id: string) => {
      dispatch(getNurtureLeadBoard(id));
    },
    DeleteEmails: (data: any) => {
      dispatch(deleteInboundEmail(data));
    },
    ImapEmailSync: (data: ImapSyncData) => {
      dispatch(imapSyncEmail(data));
    },
    DownloadCSVTemplate: (data: any) => {
      dispatch(getCsvTemplate(data));
    },
    ImportCSVFile: (body: ImportCSVData) => {
      dispatch(importCsvFile(body));
    },
    GetCourseList: (id: string) => {
      dispatch(getAllCourseByInstituteRequest(id));
    },
    GetContactLists: (
      id: string,
      lastEvaluatedKey: string,
      limit: number,
      lastEvaluatedSortKey: string,
      branchId: string
    ) => {
      dispatch(
        getContactList({
          id,
          lastEvaluatedKey,
          limit,
          lastEvaluatedSortKey,
          branchId,
        })
      );
    },
    DeleteContactList: (data: DeleteContactData) => {
      dispatch(deleteContactList(data));
    },
    GetBranchList: (id: string) => {
      dispatch(getBranchList(id));
    },
    GetBatchList: (data: any) => {
      dispatch(getBatchList(data));
    },
    AddEnquiryForContact: (data: AddEnquiryDataFromContact) => {
      dispatch(addEnquiryForContact(data));
    },
    GetInstituteById: (id: string) => {
      dispatch(getInstituteById(id));
    },
    GetCourseById: (id: string) => {
      dispatch(getCourseByIdRequest(id));
    },
    GetBatchById: (id: string) => {
      dispatch(getBatchById(id));
    },
  };
};
export interface InboundProps extends StateProps, DispatchProps {}
export const EmailComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailData);
